<template>
  <div
    v-if="!hideContent"
    ref="form"
    class="form"
    :class="{'en-form': isEnglish}"
  >
    <a-form
      v-if="formData"
      :form="form"
    >
      <div
        v-for="(modules, k) in formData"
        :key="k"
        :data-key="modules.fieldkey"
      >
        <div
          v-if="modules && k !== 'audit_info' && !(modules.fieldkey === 'from_info' || modules.fieldkey === 'reception_info' || modules.fieldkey === 'info')"
          v-show="modules.fieldkey !== 'deal_info' || (modules.fieldkey === 'deal_info' && modules.show)"
          :id="`anchor_${modules.fieldkey}`"
          class="module"
          :class="{ 'hide': hideModule(k) }"
        >
          <h2 class="title">
            {{ modules.fieldname }}
          </h2>

          <!-- 表单循环的主题部分 start -->
          <my-item
            v-for="(item) in modules.child"
            v-show="item.fieldtype ? true : false"
            :id="item.fieldkey"
            :key="item.fieldkey"
            class="clearfix"
            :data="item"
            :modules-data="modules"
            @change="handleChangeItem($event, item)"
            @delete="handleDeleteItem"
          />
          <!-- 表单循环的主题部分 end -->
        </div>
      </div>
      <!-- 信息来源部分特殊处理 start -->
      <div
        v-if="fromInfo"
        id="anchor_from_info"
        class="module from-info"
      >
        <h2
          class="title"
        >
          {{ fromInfo.fieldname }}
        </h2>
        <template v-if="receptionInfo && receptionInfo.child && receptionInfo.child.length && !isClue">
          <not-can-edit-item
            v-if="!receptionInfo.child[0].isedit"
            :data="receptionInfo.child[0]"
          />
          <my-item
            v-else
            :data="receptionInfo.child[0]"
            class="reception-info"
          />
        </template>
        <template v-if="fromInfo">
          <my-item
            v-if="fromInfo.isedit"
            :value="currentFrom"
            :data="fromInfo"
            class="clearfix"
            @change="handleChangeFromSource"
          />

          <not-can-edit-item
            v-if="!fromInfo.isedit"
            :data="fromNotEditItem"
          />
          <template v-if="currentFrom && !isClue">
            <my-item
              v-for="(item) in fromInfo.childObj && fromInfo.childObj[currentFrom] && fromInfo.childObj[currentFrom].child"
              :id="item.fieldkey"
              :key="item.fieldkey"
              class="clearfix"
              :data="item"
              :modules-data="fromInfo"
              :current-from="currentFrom"
              @delete="handleDeleteItem"
            />
          </template>
        </template>
      </div>
      <!-- 信息来源部分特殊处理 end -->
      <!-- 人员信息 -->
      <div
        v-if="formData.info && !isClue"
        id="anchor_info"
        class="module member-info"
      >
        <h2
          class="title"
        >
          {{ formData.info.fieldname }}
        </h2>
        <member-edit
          ref="memberInfo"
          :data="formData.info"
          @change="handleChangeMember"
        />
      </div>
    </a-form>
    <!-- 表单按钮 start -->
    <div
      v-if="showFooter"
      class="footer-wrap"
    >
      <div
        v-if="permissionInfo"
        ref="footer"
        class="footer clearfix"
      >
        <!-- 状态是 待审核，按钮显示 通过，拒审 -->
        <a-button
          v-if="permissionInfo.is_show_approval"
          type="primary"
          :loading="confirmLoading"
          @click="handleSubmit(saveType = 'pass')"
        >
          {{ $t('message["1206"]') }}
        </a-button>
        <!--  -->
        <a-button
          v-if="permissionInfo.is_show_reject"
          @click="confirmReject(saveType = 'reject')"
        >
          {{ $t('message["542"]') }}
        </a-button>
        <!-- 状态是 已拒审，按钮显示 重新通过 -->
        <a-button
          v-if="!showPassTab && permissionInfo.is_show_reapproval"
          type="primary"
          :loading="confirmLoading"
          @click="handleSubmit(saveType = 'pass')"
        >
          {{ $t('message["1624"]') }}
        </a-button>
        <!-- 状态是已通过，且通过信息列表和查重进入详情页，按钮显示 保存 -->
        <a-button
          v-if="permissionInfo.is_show_save || isClue"
          type="primary"
          :loading="confirmLoading"
          @click="handleSubmit(saveType = 'save')"
        >
          {{ $t('message["21"]') }}
        </a-button>
        <a-button
          v-if=" isClue"
          html-type="reset"
          @click="handleSubmit(saveType = 'reset')"
        >
          取消
        </a-button>
        <a-button
          v-if="!showPassTab && permissionInfo && permissionInfo.is_show_del"
          type="danger"
          @click="handleDelete"
        >
          {{ $t('message["962"]') }}
        </a-button>
        <!--  -->
        <div
          v-if="permissionInfo.is_show_compare"
          class="format-history"
        >
          <span class="prompt-text">{{ $t('message["344"]') }}</span>
          <a-button
            ref="formatHistoryBtn"
            class="format-history-btn"
            @click="handleFormatHistory"
          >
            {{ $t('message["88"]') }}
          </a-button>
        </div>
      </div>
    </div>
    <!-- 表单按钮 end -->
    <reject-modal
      :visible.sync="showRejectModal"
      :inquiry-id="inquiryId"
      :audit-roleid="rejectAuditRoleid"
      :audit-groupid="rejectAuditGroupid"
    />
    <repeat-modal
      :visible.sync="showRepeatModal"
      :inquiry-id="inquiryId"
      :data="repeatData"
      :save-type="saveType"
      :again-save-form="againSaveForm"
    />
    <format-history-modal
      v-if="permissionInfo.is_show_compare"
      :visible.sync="showFormatHistoryModal"
      :form-history-id="formHistoryId"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import inquiryFormMixin from '@/lib/inquiryFormMixin'
import { inquiryEdit, inquiryApproval } from '@/services/inqueryServices'
import { editClueData } from '@/services/clue'
import MyItem from './../formItem/Item'
// import MySelect from './../formItem/Select'
import MemberEdit from './../create/MemberEdit'
import NotCanEditItem from './../formItem/NotCanEdit'
import RejectModal from './modal/RejectModal'
import RepeatModal from './modal/RepeatModal'
import FormatHistoryModal from './modal/FormatHistoryModal'
import eventBus from '@/lib/eventBus'
import { getLang } from '@/lib/storage'

const FROM_SOPURCE = 'notice'

export default {
  components: {
    MyItem,
    // MySelect,
    MemberEdit,
    NotCanEditItem,
    RejectModal,
    RepeatModal,
    FormatHistoryModal
  },
  mixins: [inquiryFormMixin],
  provide () {
    return {
      myForm: this.form
    }
  },
  props: {
    data: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      formData: this.data,
      form: this.$form.createForm(this),
      currentFrom: '',

      // 拒审数据
      showRejectModal: false,
      rejectAuditRoleid: 0,
      rejectAuditGroupid: 0,
      /* groupMemberInfo: {},
      devRelateMemberInfo: {}, */
      // 查重数据
      showRepeatModal: false,
      repeatData: [],

      // 编辑时保存的类型
      saveType: '',

      // 配置里删除的项在编辑里删除
      delfields: [],

      // 编辑保存禁止重复提交
      confirmLoading: false,

      // 查看提交记录
      showFormatHistoryModal: false
    }
  },
  computed: {
    ...mapState(['baseinfo']),
    ...mapState('inquery/detailData', ['joinTeamCascaderShow']),
    ...mapGetters('inquery/detailData', ['memberInfo', 'permissionInfo']),
    from () { // all, my, audit, checkrepeat
      return this.$route.query.from
    },
    type () {
      return this.$route.query.type
    },
    inquiryId () {
      return this.isClue ? this.$route.params.id : this.$route.params.inquiryId
    },
    hideContent () {
      if (this.from === 'audit' || !this.permissionInfo || this.isClue) return false

      return !this.permissionInfo.is_show_inquirydetail && !this.permissionInfo.is_show_fromdetail && !this.permissionInfo.is_show_followups && !this.permissionInfo.is_show_comments && !this.permissionInfo.is_show_historys
    },
    receptionInfo () {
      const { reception_info: receptionInfo = {} } = this.formData || {}
      return receptionInfo
    },
    fromInfo () {
      const { from_info: fromInfo = {} } = this.formData || {}
      return fromInfo
    },
    /* fromInfoChild () {
      const { from_info: fromInfo = {} } = this.formData || {}
      const { child = [] } = fromInfo
      return child
    }, */
    fromNotEditItem () {
      let { fieldvalue, childObj = {} } = this.formData.from_info || {}
      let obj = {}
      obj.fieldvalue = (fieldvalue && childObj[fieldvalue] && childObj[fieldvalue].fieldname) || ''
      obj.fieldname = this.formData.from_info.fromname || ''
      obj.fieldtype = 'string'
      return obj
    },
    auditStatus () {
      const { audit_status: auditStatus } = this.memberInfo || {}
      return auditStatus
    },
    showPassTab () {
      let flag = false
      if (this.from === 'audit') {
        flag = false
      } else {
        if (this.auditStatus === 0 || this.auditStatus === -1) {
          flag = false
        } else if (this.auditStatus === 1) { // 通过
          flag = true
        }
      }
      return flag
    },
    showFooter () {
      if (!this.permissionInfo) return false

      return this.permissionInfo.is_show_approval ||
        this.permissionInfo.is_show_reject ||
        (!this.showPassTab && this.permissionInfo.is_show_reapproval) ||
        this.permissionInfo.is_show_save ||
        (!this.showPassTab && this.permissionInfo.is_show_del) ||
        this.permissionInfo.is_show_compare || this.isEditCluePri
    },
    checkrepeatfieldkey () {
      return this.$route.query.checkrepeatfieldkey
    },
    formHistoryId () {
      const { form_history_id: formHistoryId } = this.memberInfo
      return formHistoryId
    },
    isEnglish () {
      return this.getLang() === 'en'
    },
    isClue () {
      return this.$route.name === 'ClueDetail'
    },
    isEditCluePri () {
      // && this.baseinfo.userid * 1 === this.formData.dev_userid * 1
      return this.isClue && this.baseinfo.userid * 1 === this.formData.info.clueUserId * 1
    }
  },
  /* watch: {
    formData: {
      handler (val) {
        const { base_info: baseInfo = {} } = val || {}
        if (!baseInfo || !baseInfo.child || !val.deal_info) return

        for (let i in val) {
          let item = val[i]
          this.$set(item, 'show', true)
        }

        const infoStatus = baseInfo.child.find(
          item => item.fieldkey === 'info_status'
        )

        if (!infoStatus || !infoStatus.options) return

        const dealStatusItem = infoStatus.options.find(
          item => item.name === this.$t('message["109"]')
        ) || {}
        const res = dealStatusItem && dealStatusItem.id === infoStatus.fieldvalue

        this.$set(val.deal_info, 'show', res)
      },
      immediate: true
    }
  }, */
  async created () {
    // 点击成交时，改变模块的显示隐藏
    /* eventBus.$on('updateForm', dealInfo => {
      this.formData.deal_info = dealInfo
      this.$forceUpdate()
    }) */
  },
  mounted () {
    // 设置来源的默认值和默认请求关联接口
    this.initFromInfo()
  },
  methods: {
    ...mapActions('inquery/detailData', ['deleteDetail']),
    getLang,

    hideModule (k) {
      let { isDeal, isInvalid, isDiscard } = this
      return (k === 'deal_info' && !isDeal) || (k === 'invalid_info' && !isInvalid) || (k === 'discard_info' && !isDiscard)
    },

    /**
     * 切换信息来源：网站，电话，邮箱等
     */
    handleChangeFromSource (val) {
      if (!this.formData || !this.formData.from_info) return

      this.formData.from_info.fieldvalue = val
      this.currentFrom = val
      this.$forceUpdate()

      if (!this.isClue) {
        this.relateTeamInfo(this.formData.from_info)
      }
    },

    /**
     * 删除配置里更改的表单项
     */
    handleDeleteItem (modulesData, fieldkey) {
      if (modulesData && modulesData.fieldkey === 'from_info' && modulesData.childObj && modulesData.childObj[this.currentFrom]) {
        let childData = modulesData.childObj[this.currentFrom].child

        childData.forEach((item, i) => {
          if (fieldkey === item.fieldkey) {
            childData.splice(i, 1)
            this.delfields.push(fieldkey)
          }
        })

        this.formData.from_info.childObj[this.currentFrom].child = childData
      } else {
        if (!modulesData.child) return

        modulesData.child.forEach((item, i) => {
          if (fieldkey === item.fieldkey) {
            modulesData.child.splice(i, 1)
            this.delfields.push(fieldkey)
          }
        })
        this.$forceUpdate()
      }
    },
    againSaveForm ({ saveType, checkrepeatconfirm }) {
      this.handleSubmit(saveType, checkrepeatconfirm)
    },

    /**
     * 点击拒审, 通过，保存时，获取拒审人员（所属团队/组）的 id
     */
    getGroupMember () {
      let { info = {} } = this.formData || {}
      let { child = [] } = info
      for (let item of child) {
        const { fieldkey, info: itemInfo = {} } = item
        if (fieldkey === 'group') {
          this.rejectAuditRoleid = itemInfo.roleid
          this.rejectAuditGroupid = itemInfo.groupid
        }
      }
      this.form.resetFields()

      // 如果是负责人/所属团队小组选项没有值，拒审时所属团队小组非必填
      if ((this.baseinfo && this.baseinfo.system_role === 1) || !this.joinTeamCascaderShow || (this.rejectAuditRoleid && this.rejectAuditGroupid)) {
        return false
      } else {
        this.form.validateFields(['group'], { force: true })
        return true
      }
    },
    /**
     * 拒审提交接口
     */
    async confirmReject (saveType) {
      let error = this.getGroupMember()
      if (!error) {
        this.showRejectModal = true
      }
    },
    /**
     * 点击保存，通过，再次通过，拒审等按钮
     * saveType：类型：save，pass，reject
     * checkrepeatconfirm: 1是点击了查重弹窗的继续保存
     */
    async handleSubmit (saveType, checkrepeatconfirm) {
      this.$bus.$emit('myQuillEditorBlur')

      this.form.validateFields(async (err, values) => {
        err = this.checkError(err)

        if (!err) {
          if (this.confirmLoading) return

          this.confirmLoading = true

          const formData = await this.setFormDataParams(this.formData)
          let params = {
            [this.isClue ? 'id' : 'inquiryid']: this.inquiryId,
            ...formData,
            delfields: this.delfields
          }
          if (checkrepeatconfirm === 1) {
            params.checkrepeatconfirm = checkrepeatconfirm
          }
          await this.comfirmForm(saveType, params)
          // await this.comfirmForm(saveType, params)
        }
      })
    },
    /**
     * params: 处理过的表单数据作为保存参数
     */
    async comfirmForm (saveType, params) {
      let chain
      let _this = this
      // 查重详情额外加参数
      if (this.from === 'checkrepeat' && this.checkrepeatfieldkey) {
        params.scope = this.from
        params.checkrepeatfieldkey = this.checkrepeatfieldkey
      }
      if (saveType === 'save') { // 点击保存按钮
        chain = this.isClue ? await editClueData() : await inquiryEdit()
        chain
          .onSuccess(() => { // 保存成功跳转到列表
            // console.log('[保存]', this.inquiryId)
            eventBus.$emit('fetchInquiryDetail', this.inquiryId)
            this.form.resetFields()
          })
          .onNetSuccess(raw => {
            this.confirmLoading = false
            const { data } = raw
            if (data.error === 104) { // 有重复
              this.showRepeatModal = true
              this.repeatData = data.payload
            }
          })
          .config({
            error104: false,
            error100 (raw) {
              // TODO: 处理后端错误
              let msg = ''
              if (raw.message) {
                msg = raw.message
              } else if (raw.payload && raw.payload.length) {
                msg = raw.payload[0]
              }
              _this.$message.destroy()
              _this.$message.error(msg)
            }
          })
          .params(params).fetch()
      } else if (saveType === 'pass') { // 点击通过/重新通过按钮
        chain = await inquiryApproval()
        chain
          .onSuccess(() => { // 保存成功跳转到待审核列表
            if (this.from === FROM_SOPURCE) {
              this.$router.push({ name: 'recordNotice' })
            } else if (this.from === 'webhook') {
              this.$router.push({
                name: 'configSendRecord',
                params: {
                  hookid: this.$route.query.hookid
                }
              })
            } else if (this.from === 'clue') {
              this.$router.push({
                name: 'InqueryClue'
              })
            } else if (this.from === 'ocpc') {
              this.$router.push({
                name: 'ocpc'
              })
            } else if (this.from && !this.type) {
              this.$router.go(-1)
            } else {
              if (this.from === 'audit') {
                this.$router.push({
                  name: 'InqueryAudit',
                  query: {
                    type: this.type || 'wait-audit',
                    from: this.from
                  }
                })
              } else {
                this.$router.push({
                  name: 'InqueryList',
                  query: {
                    type: this.type,
                    from: this.from
                  }
                })
              }
              this.form.resetFields()
            }
          })
          .onNetSuccess(raw => {
            this.confirmLoading = false
            const { data } = raw
            if (data.error === 104) { // 有重复
              this.showRepeatModal = true
              this.repeatData = data.payload
            }
          })
          .config({
            error104: false,
            error100 (raw) {
              // TODO: 处理后端错误
              let msg = ''
              if (raw.message) {
                msg = raw.message
              } else if (raw.payload && raw.payload.length) {
                msg = raw.payload[0]
              }
              _this.$message.destroy()
              _this.$message.error(msg)
            }
          })
          .params(params).fetch()
      } else if (saveType === 'reset') {
        this.$router.push({
          name: 'InqueryClue',
          query: this.$router.query,
          params: {
            id: this.inquiryId
          }
        })
      }
      /* else if (saveType === 'reject') {
        this.showRejectModal = true
      } */
      // 保存前要判断查重，有重复弹窗展示
    },

    /**
     * 删除询盘
     */
    async handleDelete () {
      this.$confirm({
        title: this.$t('message["493"]'),
        content: this.$t('message["969"]') + '？',
        okText: this.$t('message["915"]'),
        okType: 'danger',
        cancelText: this.$t('message["896"]'),
        onOk: async () => {
          const chain = await this.deleteDetail()
          chain
            .onSuccess((raw, res) => {
              if (!res.error) {
                let name = ''
                if (this.from === 'audit') {
                  name = 'InqueryAudit'
                } else if (this.from === 'checkrepeat') {
                  name = 'InqueryRepeat'
                } else {
                  name = 'InqueryList'
                }
                if (this.from && this.type) {
                  this.$router.push({
                    name,
                    query: {
                      type: this.type,
                      from: this.from
                    }
                  })
                } else if (this.from === FROM_SOPURCE) {
                  this.$router.push({ name: 'recordNotice' })
                } else if (this.from === 'webhook') {
                  this.$router.push({
                    name: 'configSendRecord',
                    params: {
                      hookid: this.$route.query.hookid
                    }
                  })
                } else if (this.from === 'clue') {
                  this.$router.push({
                    name: 'InqueryClue'
                  })
                } else if (this.from === 'ocpc') {
                  this.$router.push({
                    name: 'ocpc'
                  })
                } else {
                  this.$router.go(-1)
                }
              }
            })
            .params({
              inquiryid: this.inquiryId
            })
            .fetch()
        },
        onCancel () {
          console.log('Cancel')
        }
      })
    },
    // 查看提交记录
    handleFormatHistory () {
      this.showFormatHistoryModal = true
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  margin-top: 24px;
  .module {
    padding-bottom: 40px;
    border-top: solid 1px $gray4;
  }
  .reception-info {
    padding-bottom: 24px;
    border-bottom: solid 1px #ebebeb;
  }
  .footer-wrap {
    width: 100%;
    height: 64px;
  }
  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 998;
    height: 64px;
    margin-left: -40px;
    padding: 16px 0 16px 180px;
    background-color: #fff;
    border-top: solid 1px $gray4;
    .format-history {
      float: right;
      margin-right: 24px;

      .prompt-text {
        color: #f6a953;
        font-size: 14px;
      }
    }
    .format-history-btn {
      margin-left: 20px;
    }
  }
}
.en-form::v-deep {
  .ant-form-item-label {
    width: 200px;
    text-overflow: ellipsis;
    label {
      white-space: nowrap;
    }
  }
  .ant-form-item-control-wrapper {
    padding-left: 200px;
  }
   .ant-form-item-label label::after{
    content: '';
  }
  .ant-form-item-label::after {
    content: ':';
    position: absolute;
    left: 182px;
    top: 0;
    color: #666;
  }
}
</style>
<style lang="scss">
.clue-invalid-modal {
  .clue-invalid-tip{
    margin-top: 10px;
  color: #666;
  line-height: 24px;
}
  .clue-invalid-color{
    color:#f57676;
  }
  .ant-modal-close{
    display: none;
  }
  .ant-btn{
    i {
      display: none;
    }
  }
}

</style>
